import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ProvisioningFlow } from '@/features/onboarding/ProvisioningFlow'

const setupSearchSchema = z.object({
  name: z.string().optional(),
})

export const Route = createFileRoute('/onboarding/setup/$accountId')({
  validateSearch: setupSearchSchema,
  component: SetupPage,
  staticData: { authorize: true, requiresAccount: false, noShell: true },
})

function SetupPage() {
  const { accountId } = Route.useParams()
  const { name } = Route.useSearch()
  return <ProvisioningFlow accountId={Number(accountId)} orgName={name} />
}
